import React, { Component } from 'react';
import { Query } from 'react-apollo';
import './styles.scss';
import AdminGamesManager from '../AdminGamesManager';
import gql from 'graphql-tag';

const ADMIN_GAMES_QUERY = gql`
	query adminGameQuery($page: Int, $coordinator: Boolean, $sessionID: String) {
		user {
			id
			username
			password
			firstName
			lastName
			roles
			gamesCount
			paginatedGames(
				page: $page
				coordinator: $coordinator
				sessionID: $sessionID
			) {
				id
				edges {
					id
					data
					session {
						id
						name
					}
					player {
						id
						username
						password
						firstName
						lastName
						roles
					}
				}
				paginationInfo {
					id
					currentPage
					pageCount
				}
			}
		}
	}
`;
class AdminGames extends Component {
	constructor(props) {
		super(props);

		this.state = {
			gamePage: 1,
			gameCoordinator: false,
			gameSessionID: null
		};
	}
	render() {
		const { gamePage, gameCoordinator, gameSessionID } = this.state;
		return (
			<Query
				query={ADMIN_GAMES_QUERY}
				fetchPolicy={'cache-and-network'}
				variables={{
					page: gamePage,
					coordinator: gameCoordinator,
					sessionID: gameSessionID
				}}>
				{({ data, refetch }) => {
					if (!data.user) {
						return null;
					}
					return (
						<div className="AdminGames">
							<AdminGamesManager
								{...this.props}
								refetch={refetch}
								paginatedGames={data.user.paginatedGames}
								coordinator={gameCoordinator}
								sessionID={gameSessionID}
								setQueryState={state => this.setState(state)}
								page={gamePage}
							/>
						</div>
					);
				}}
			</Query>
		);
	}
}

export default AdminGames;
